<template>
  <Modal
    :show="show.filter"
    :width="layout"
    :cancel-text="null"
    :disabled="emptyFilters"
    :clear-text="clearText"
    action-text="Apply Filters"
    @close="$emit('close')"
    @clear="$emit('clear'); $emit('close')"
    @action="$emit('apply-filters'); $emit('close')"
  >
    <template #title>
      Select Filters
    </template>

    <template #content>
      <v-container>
        <v-row v-if="emptyFilters">
          No filters are available for the selected data.
        </v-row>
        <v-row v-else>
          <v-col
            v-for="(value, key, i) in columns"
            :key="i"
            :cols="colWidth"
            class="pa-0"
            :class="{
              'pl-3': key === 'col2',
              'pr-3': key === 'col1' && columns.col2,
            }"
          >
            <div
              v-for="(field, index) in value.fields"
              :key="index"
              :class="index === value.fields.length - 1 ? 'mb-0' : 'mb-6'"
            >
              <FilterModalItem
                :field="field"
                :col="key"
                @set-temp-filters="$emit('set-temp-filters', $event)"
                @add-snackbar="addErrorSnackbar"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal.vue';
import FilterModalItem from '@/components/filter/filterMenu/FilterModalItem.vue';
import { isEmpty } from 'lodash-es';
import { mapState, mapActions } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useFilters } from '@/stores/filters/filters';
import { useAppSnackbar } from '@/stores/app/snackbar';

export default {
  name: 'FilterModal',
  components: {
    Modal,
    FilterModalItem,
  },
  emits: ['set-temp-filters', 'apply-filters', 'close', 'clear'],
  computed: {
    ...mapState(useModals, ['show']),
    ...mapState(useFilters, ['tempFilters', 'activeFilters']),
    clearText() {
      return this.activeFilters ? 'CLEAR FILTERS' : false;
    },
    emptyFilters() {
      return isEmpty(this.tempFilters);
    },
    columns() {
      const columns = {};
      const col1 = { name: 'col1', fields: [] };
      const col2 = { name: 'col2', fields: [] };
      this.tempFilters.forEach((field, index) => {
        if (field.position === 'column_1') {
          col1.fields.push({ ...field, index });
        }
        if (field.position === 'column_2') {
          col2.fields.push({ ...field, index });
        }
      });
      [col1, col2].forEach((column) => {
        if (column.fields.length) {
          columns[column.name] = column;
        }
      });
      return columns;
    },
    layout() {
      return this.columns?.col2 ? 'large' : 'medium';
    },
    colWidth() {
      return (this.layout === 'medium') ? 12 : 6;
    },
  },
  methods: {
    ...mapActions(useAppSnackbar, ['addErrorSnackbar']),
  },
};
</script>
